import React from 'react'
import { gallery } from '../Data/Gallery'
import { Link } from 'react-router-dom'
import { Zoom } from 'react-awesome-reveal'
import { Container, Icon } from 'semantic-ui-react'
import bannerPic1 from '../Pictures/banner1.jpg'

export default function GalleryPage() {
  const bannerStyle = {
    backgroundImage: `url(${bannerPic1})`,
  }

  // Extract unique categories
  const categories = Array.from(new Set(gallery.map(item => item.category)))

  const albumList = categories.map(categoryName => {
    const items = gallery.filter(item => item.category === categoryName)
    return {
      name: categoryName,
      id: items[0]?.id || 1,
      cover: items[0]?.thumbnail || items[0]?.original,
      count: items.length,
    }
  })

  return (
    <div id='galleryPage'>
      {/* Hero Banner */}
      <section className='pageHero' style={bannerStyle}>
        <div className='pageHeroOverlay'></div>
        <div className='pageHeroContent'>
          <Zoom triggerOnce>
            <span className='pageHeroBadge'>Moments & Memories</span>
            <h1 className='pageHeroHeading'>Community Gallery</h1>
            <div className='goldAccentLine' style={{ margin: '14px auto 20px auto' }}></div>
            <p className='pageHeroSubheading'>
              Explore snapshots of our cultural gatherings, annual get-togethers, welfare outreach, and summer events.
            </p>
            <div style={{ marginTop: '20px' }}>
              <Link to='/gallery/all' className='bannerPrimaryBtn'>
                <Icon name='images outline' /> View All Photos ({gallery.length})
              </Link>
            </div>
          </Zoom>
        </div>
      </section>

      {/* Album Grid Section */}
      <section className='homeSection'>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Collections</span>
            <h2 className='homeSectionTitle'>Photo Albums</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              Select an album to browse event highlights or view the entire collection.
            </p>
          </div>

          <div className='albumGrid'>
            {albumList.map(album => (
              <article className='albumCard' key={album.name}>
                <Link to={`/gallery/${album.id}`} className='albumCardLink'>
                  <div className='albumPhotoWrapper'>
                    <img
                      src={album.cover}
                      alt={album.name}
                      className='albumCoverImg'
                      loading='lazy'
                    />
                    <span className='albumCountBadge'>
                      <Icon name='camera' /> {album.count} Photos
                    </span>
                  </div>
                  <div className='albumDetails'>
                    <h3 className='albumTitle'>{album.name}</h3>
                    <span className='albumActionLink'>
                      Open Album <Icon name='arrow right' />
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </Container>
      </section>
    </div>
  )
}
